// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + ".bundle.js?" + {"932":"7c223b6e5d1d09d62e53","940":"68e4ebe3a8b3e47b1e10"}[chunkId] + "";
};